(function (angular) {
	'use strict';

	angular.module('campaignCtaModule', [
		'BaseConfig',
		'localStorageModule',
		'waitlistModule'
	]);
})(window.angular);